<script setup lang="ts">
import { inject } from 'vue';

import { emptyFunc } from '@/utils/funcs';
import { noticesMarkAllAsReadKey } from '@/constants/injectionKeys';

export interface Props {
  isMarkAllDisabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isMarkAllDisabled: false,
});

const markAllAsRead = inject(noticesMarkAllAsReadKey, emptyFunc);
</script>

<template>
  <header :class="$style.noticesTabWinHeader" data-testid="noticesTabWinHeader">
    <div>Latest</div>
    <v-btn
      v-if="!props.isMarkAllDisabled"
      :ripple="false"
      :class="$style.btn"
      variant="plain"
      density="compact"
      :disabled="props.isMarkAllDisabled"
      @click="markAllAsRead"
    >
      Mark all as read
    </v-btn>
  </header>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.noticesTabWinHeader {
  font-size: 1.125rem;
  display: flex;
  justify-content: space-between;
  padding: 20px 25px 10px 25px;
}
  .btn {
    padding: 0 !important;
    color: colors.$color-brand-800;
    opacity: 1;

    &:hover {
      color: colors.$color-brand-400;
    }
    &:active {
      color: colors.$color-brand-300;
    }
    &:disabled {
      opacity: 0.26;
    }

    :global {
      .v-btn__content {
        font-size: 1.125rem;
        text-transform: none;
        letter-spacing: normal;
        font-weight: normal;
      }
    }
  }
</style>
